module.exports = __webpack_public_path__ + "img/car_shina2_16.edc7ce45.jpg";